// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footer-module--footerWrapper--1WSgO","siteInfo":"footer-module--siteInfo--yY_Aa","glow":"footer-module--glow--3mhqE"};